export default function user() {
  return 0
}

export function getUsuarios(state) {
  return state.usuarios
}
